import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SettingResep } from '../../models/setting-resep.model';
import { SettingResepApiService } from '../api/setting-resep.api.service';
import { DataService } from './data.service';

@Injectable({
  providedIn: 'root',
})
export class SettingResepDataService implements DataService<SettingResep> {
  constructor(private settingResepApiService: SettingResepApiService) {}

  public getSetting(): Observable<any> {
    return this.settingResepApiService.getSetting();
  }

  public create(data: any): Observable<any> {
    return this.settingResepApiService.create(data);
  }

  public update(id: number, data: any): Observable<any> {
    return this.settingResepApiService.update(id, data);
  }
}
